import { ApartmentOutlined } from '@ant-design/icons';
import { Space, Typography } from 'antd';
import { OrganizationTab } from '../../model/types';

const { Text } = Typography;

interface Props {
    tab: OrganizationTab;
}

const styles = {
    icon: { fontSize: '1.2rem' },
    infoSection: { minWidth: 100, maxWidth: 100, textOverflow: 'ellipsis', overflow: 'hidden' },
    text: { fontSize: 13 }
};

const OrganizationTabComponent = ({ tab }: Props) => {
    const { name } = tab;

    return (
        <Space size="small">
            <ApartmentOutlined style={styles.icon} />

            <div style={styles.infoSection}>
                <Text strong style={styles.text}>
                    {name}
                </Text>
            </div>
        </Space>
    );
};

export default OrganizationTabComponent;
